import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { Autocomplete, TextField } from "@mui/material";

export default function UserNavbar({ setViolationTitleInput, violationTitleInput, setSortValue, sortValue, violations, setCurrPage, setBulkCheck}) {
    const navigate = useNavigate();

    return (
        <div className="header-container" style={{marginBottom: "10px"}}>      
            <FaSearch style={{marginRight: "5px", marginTop:"2px"}} className="search-icon"/> 
        
            <Autocomplete size="small" disablePortal options={violations.map((option) => option.arsCode)} sx={{ width: 300, marginRight: 'auto', marginLeft: 0, 
                marginTop: '10px', marginBottom: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', borderRadius: '4px' }}
                    renderInput={(params) => (
                        <TextField {...params} label="Search Violations" sx={{ "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { 
                            "&.Mui-focused fieldset": { border: "1px solid black", color: "black" }, }, backgroundColor: "white", borderRadius: '4px' }}/>
                        )}
                        value={violationTitleInput.trim()}   
                        onInputChange={(event, newInputValue) => {
                            setViolationTitleInput(newInputValue || "");
                            navigate("/dashboard/page/1");
                            setCurrPage(1);
                        }}
            />

            <select className="sort-dropdown" value={sortValue} onChange={(e) => {setSortValue(e.target.value);}} name="sort-dropdown">
                <option value="">Sort By</option>
                <option value="arsCode-asc">ARS-Code (A-Z)</option>
                <option value="arsCode-desc">ARS-Code (Z-A)</option>
                <option value="startDate-desc">Start Date (Newest)</option>
                <option value="startDate-asc">Start Date (Oldest)</option>
                <option value="fine-desc">Fine (High to Low)</option>
                <option value="fine-asc">Fine (Low to High)</option>
                <option value="proof-info">Proof/Info</option>
            </select>

            <div className="header-actions">
                <button className="bulk-edit-button" title="Bulk Edit" onClick={() => setBulkCheck(true)}>Bulk Update</button>
            </div> 
        </div>
    );
}
